<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()" v-slot="{ errors }">
        <div class="d-flex justify-content-between align-items-center"> 
            <div class="w-100 mr-4">
                <label for="email">Email</label>
                <ValidationProvider name="email" rules="" v-slot="{ errors }">
                    <input v-model="email" placeholder="Email" class="form-control" id="email" type="email" />
                    <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="font-size: 11px ; display: block; background-color: #DC3545; color: white; padding: 6px; margin-top: 10px;"><b>{{ errors[0] }}</b></span>
                </ValidationProvider>
            </div>
            <Button id="add-email" variant="success" @click="addEmail" :disabled="!email || errors.email?.length > 0">
                <i class="fa fa-plus"></i>
            </Button>
        </div>
        <b-col cols="12" v-if="emails.length" class="mt-3 p-0">
            <ul class="list-group">
                <li v-for="(email, index) in emails" :key="index" class="list-group-item d-flex justify-content-between align-items-center">
                    {{ email }}
                    <Button variant="danger" size="sm" @click="removeEmail(index)">
                        <i class="fa fa-times"></i>
                    </Button>
                </li>
            </ul>
        </b-col>
        <b-col cols="12" class="text-right mt-4">
            <Button type="submit" name="button" :disabled="disabled">GUARDAR</Button>
        </b-col>
    </ValidationObserver>
</template>

<script>
    export default {
        props: {
            loading: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                email: null,
                emails: []
            }
        },
        methods: {
            async addEmail() {
                const isValid = await this.$refs.observer.validate();
                if (isValid && this.email && !this.emails.includes(this.email)) {
                    this.emails.push(this.email);
                    this.email = null;
                }
            },
            removeEmail(index) {
                this.emails.splice(index, 1);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.$emit('terminado', this.emails);
                    this.emails = [];
                    this.email = null;
                }
            }
        },
        computed: {
            disabled() {
                return !this.emails.length || this.loading;
            }
        }
    }
</script>

<style scoped>
.list-group-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 1rem;
    border: 1px solid #e3e3e3;
    border-radius: 0.25rem;
    margin-bottom: 0.5rem;
}
.list-group-item button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
}
</style>